export default __webpack_public_path__ + "static/media/flutterImg1.8d43195b.jpg";